

























































import Vue from "vue";
import Component from "vue-class-component";
import { CommunityInterface } from "@/types";
import CommunityCallout from "@/components/community/CommunityCallout.vue";

@Component({
  components: { CommunityCallout },
  metaInfo: {
    title: "Communities – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Explore communities affiliated with the Newfound Pioneer Corps Arma 3 unit." },
      { vmid: "og:title", property: "og:title", content: "Communities – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Explore communities affiliated with the Newfound Pioneer Corps Arma 3 unit." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/communities" },
    ],
  },
})
export default class Communities extends Vue {
  private communities: CommunityInterface[] = [];
  private loading: boolean = true;

  public async mounted() {
    try {
      const response = await this.axios.get("/community/communities");
      this.communities = (response.data as CommunityInterface[]).filter((c) => !c.mainCommunity);
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to load communities.");
    } finally {
      this.loading = false;
    }
  }
}
